import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

export default function LoadingScreen({ onDone }) {
  const [progress, setProgress] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    let p = 0;
    const id = setInterval(() => {
      p += Math.random() * 14 + 6;
      if (p >= 100) {
        p = 100;
        clearInterval(id);
        setTimeout(() => {
          setShow(false);
          onDone?.();
        }, 450);
      }
      setProgress(Math.round(p));
    }, 130);
    return () => clearInterval(id);
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="loading-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
          className="fixed inset-0 z-[100] bg-[#050E1A] flex flex-col items-center justify-center"
        >
          {/* Particles */}
          <div className="absolute inset-0 overflow-hidden">
            {[...Array(20)].map((_, i) => (
              <motion.span
                key={i}
                className="absolute w-1 h-1 rounded-full bg-[#16A34A]/60"
                style={{ left: `${Math.random() * 100}%`, top: `${Math.random() * 100}%` }}
                animate={{ y: [-20, 20, -20], opacity: [0.2, 0.9, 0.2] }}
                transition={{ duration: 3 + Math.random() * 3, repeat: Infinity, delay: Math.random() * 2 }}
              />
            ))}
          </div>

          <motion.svg
            width={120}
            height={120}
            viewBox="0 0 64 64"
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <motion.path
              d="M32 4 L60 60 L48 60 L32 28 L16 60 L4 60 Z"
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="1.5"
              strokeDasharray="220"
              strokeDashoffset="220"
              animate={{ strokeDashoffset: 0, fill: "#FFFFFF" }}
              transition={{ duration: 1.6, ease: "easeInOut" }}
            />
            <motion.path
              d="M10 38 Q 32 8 56 30"
              fill="none"
              stroke="#16A34A"
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray="100"
              strokeDashoffset="100"
              animate={{ strokeDashoffset: 0 }}
              transition={{ duration: 1.4, delay: 0.4, ease: "easeInOut" }}
            />
          </motion.svg>

          <div className="mt-6 text-white/80 text-xs tracking-[0.5em] font-bold">
            ADMIN <span className="text-[#16A34A]">APEX</span>
          </div>

          <div className="mt-8 w-56 h-[3px] bg-white/10 rounded-full overflow-hidden">
            <motion.div
              className="h-full bg-gradient-to-r from-[#16A34A] to-emerald-300"
              style={{ width: `${progress}%` }}
              transition={{ ease: "easeOut" }}
            />
          </div>
          <div className="mt-2 text-[11px] text-white/50 tracking-widest" data-testid="loading-progress">
            {progress}%
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
